// import utils
import * as yup from 'yup';
import { t } from 'i18next';
import dayjs from 'dayjs';
import { buildDutyCodeKey } from './SelectSettlementType.utils';
import { EndOfEmploymentSettlementEnums } from 'components/admin-portal/CLA/CLASettings/CLASettings.enums';

const dutyCodeTest = (fieldName: 'extraHours' | 'leaveHours' | 'plbHours') =>
  yup
    .number()
    .nullable()
    .test(
      'missing-duty-code',
      t('endOfEmploymentSettlement.tooltip.missingDutyCode'),
      function (value) {
        if (value === 0) return true;
        const endOfEmploymentData = (
          this.options.context as { endOfEmploymentData?: any } | undefined
        )?.endOfEmploymentData;

        const raw = this.parent.endOfEmploymentSettlementType as
          | string
          | undefined;

        const settlementType = raw as
          | keyof typeof EndOfEmploymentSettlementEnums
          | undefined;

        const dutyCodeKey = buildDutyCodeKey(settlementType, fieldName);
        const showWarning =
          dutyCodeKey !== undefined &&
          endOfEmploymentData?.[dutyCodeKey] === null;

        return !showWarning;
      }
    );

export const endOfEmploymentSchema = yup.object({
  name: yup.string().required(),
  employmentNumber: yup.string().required(),
  endOfEmploymentSettlementDate: yup
    .string()
    .required(t('required'))
    .test('isValidDate', 'Invalid date format', (value) =>
      dayjs(value, 'DD-MM-YYYY', true).isValid()
    ),
  endOfEmploymentSettlementType: yup
    .string()
    .typeError(t('endOfEmploymentSettlement.validation.selectSettlementType'))
    .oneOf(
      ['TRANSFER', 'SETTLE', 'PAY_OUT'],
      t('endOfEmploymentSettlement.validation.selectSettlementType')
    )
    .required(t('required')),
  validEmployment: yup
    .string()
    .nullable()
    .when('endOfEmploymentSettlementType', {
      is: 'TRANSFER',
      then: (schema) =>
        schema.required(
          t('endOfEmploymentSettlement.validation.selectValidEmployment')
        ),
      otherwise: (schema) => schema.nullable().notRequired()
    }),

  extraHours: dutyCodeTest('extraHours'),
  leaveHours: dutyCodeTest('leaveHours'),
  plbHours: dutyCodeTest('plbHours')
});
